<template>
  <div class="login">
    <div class="login-wrapper">
      <div class="login-container" style="">
        <div class="login-form-wrapper">
          <div class="login-image-wrapper">
            <img-component
              :is-jpg="false"
              name="login_img"
              path=""
            ></img-component>
          </div>
          <div class="verticalSpacer"></div>
          <div>
            <div class="login-form-header">
              <span class="fontBold">관리자 로그인</span>
            </div>
            <div class="login-form-container">
              <div>
                <input
                  type="text"
                  v-model="userId"
                  placeholder="아이디를 입력해주세요."
                />
              </div>
              <div>
                <input
                  type="password"
                  v-model="userPw"
                  placeholder="비밀번호를 입력해주세요."
                />
              </div>
              <div style="login-btn-wrapper">
                <div class="login-btn fontS" @click="doLogin()">로그인</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {loginUser} from "../api/index";
import ImgComponent from "../components/imageComponent.vue";
// import Constant from "../store/constant";
export default {
  components: {ImgComponent},
  data() {
    return {
      userId: "",
      userPw: "",
      isJpg: false,
      isDesktop: true,
    };
  },
  methods: {
    doLogin() {
      // 로그인 검증
      const userData = {
        USER_ID: this.userId,
        USER_PW: this.userPw,
      };
      loginUser(userData)
        .then((result) => {
          if (result.status === 200) {
            localStorage.loginUser = result.data.UserId;
            this.$router.go(-1);
          } else {
            alert("로그인 정보가 일치하지 않습니다.");
            this.userId = "";
            this.userPw = "";
          }
        })
        .catch((error) => alert(error.message));
    },
  },
  mounted() {},
};
</script>

<style scoped>
.login {
  display: flex;
  height: 100vh;
  width: 100%;
}
.login-wrapper {
  width: 450px;
  margin: auto;
}
.login-container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  margin: auto;
  border-radius: 16px;
}
input {
  width: calc(100% - 42px);
  padding: 14px 20px;
  border-radius: 10px;
  border: 1px solid #d5d5d5;
  font-family: "arial";
}
input::placeholder {
  font-family: "Nanum Square";
}
.login-btn {
  text-align: center;
  margin: 0 auto;
  background: black;
  color: white;
  padding: 14px 5px !important;
  border-radius: 10px;
}
.login-form-wrapper {
  padding: 60px;
  margin: auto;
  /* border: 1px solid black; */
  border-radius: 10px;
}
.login-form {
  width: 400px;
  max-width: 400px;
}
.login-form-header {
  text-align: center;
  padding-bottom: 10px;
}
.login-form-header span {
  font-weight: bold;
  font-size: 20px;
  color: #303643;
}
.login-form-container div {
  padding: 10px 0;
}
.login-form-container div.login-btn-wrapper {
  padding: 10px 0;
}
.login-image-wrapper {
  width: 60%;
  margin: auto;
}
</style>
